import useInterval from '@hooks/useInterval';

/*
 * Lets us know when Gladly Chat is loaded since we are now
 * gonna programmatically launch it. We could also import HtGladlyChat and return the
 * methods when loaded.
 *
 * This is needed because we are not auto loading it.
 * */
export default function useGladlyChatLoaded(start: boolean = false) {
  const { callbackValue } = useInterval(
    () => {
      if ('Gladly' in window) {
        return true;
      }
      return false;
    },
    start ? 500 : 0,
    start ? 30 : 1,
  );

  const gladlyLoaded = Boolean(callbackValue);

  return { gladlyLoaded };
}
